import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { IMAGE_BUCKET_OPTIONS, ImagebucketOption } from '../../utils/imagebucket-assets';

export type ImagebucketPickMode = 'cover' | 'gallery';

@Component({
  selector: 'app-imagebucket-picker',
  imports: [CommonModule, MatButtonModule],
  templateUrl: './imagebucket-picker.component.html',
  styleUrl: './imagebucket-picker.component.sass'
})
export class ImagebucketPickerComponent {
  readonly options: readonly ImagebucketOption[] = IMAGE_BUCKET_OPTIONS;

  @Input() coverUrl = '';
  @Input() galleryUrls: string[] = [];

  @Output() pick = new EventEmitter<{ mode: ImagebucketPickMode; url: string }>();

  mode: ImagebucketPickMode = 'cover';

  tileClass(opt: ImagebucketOption): Record<string, boolean> {
    const cover = this.normalizeUrl(this.coverUrl) === opt.url;
    const inGallery = this.galleryUrls.some((u) => this.normalizeUrl(u) === opt.url);
    return {
      'imagebucket-picker__tile--cover': cover,
      'imagebucket-picker__tile--gallery': inGallery && !cover
    };
  }

  emitPick(url: string): void {
    this.pick.emit({ mode: this.mode, url });
  }

  private normalizeUrl(u: string): string {
    return u?.trim() ?? '';
  }
}
